export const LINEAR_OPERATORS = [
	"=",
	"!=",
	"<>",
	">",
	"<",
	">=",
	"<=",
	"LIKE",
	"GLOB",
	"IS",
	"IS NOT",
] as const;
export type LinearOperator = (typeof LINEAR_OPERATORS)[number];
const LINEAR_OPERATORS_SET = new Set(LINEAR_OPERATORS);

export const isLinearOperator = (o: unknown): o is LinearOperator =>
	typeof o === "string" && LINEAR_OPERATORS_SET.has(o as LinearOperator);

export const BILINEAR_OPERATORS = ["IN", "NOT IN"] as const;
export type BilinearOperator = (typeof BILINEAR_OPERATORS)[number];
const BILINEAR_OPERATORS_SET = new Set(BILINEAR_OPERATORS);
export const isBilinearOperator = (o: unknown): o is BilinearOperator =>
	typeof o === "string" && BILINEAR_OPERATORS_SET.has(o as BilinearOperator);

export const BINARY_OPERATORS = [
	"=",
	"!=",
	"<>",
	">",
	"<",
	">=",
	"<=",
	"LIKE",
	"GLOB",
	"IN",
	"NOT IN",
	"IS",
	"IS NOT",
] as const;
export type BinaryOperator = (typeof BINARY_OPERATORS)[number];

export const TERNARY_OPERATORS = ["BETWEEN", "NOT BETWEEN"] as const;
export type TernaryOperator = (typeof TERNARY_OPERATORS)[number];

const COMPARISON_OPERATORS = new Set([...BINARY_OPERATORS, ...TERNARY_OPERATORS]);

export type ComparisonOperator = BinaryOperator /*| TernaryOperator*/;

export function isComparisonOperator(o: unknown): o is ComparisonOperator {
	return typeof o === "string" && COMPARISON_OPERATORS.has(o as ComparisonOperator);
}
